import {css} from '@logistics-frontend/blocks/theme/css'

import pointSrc from './assets/point.svg'

const BASE_SIZE = 48
const TAIL_SIZE = 3

export const classes = {
  root: css`
    width: ${BASE_SIZE}px;
    height: ${BASE_SIZE}px;
    color: #fff;
    position: relative;
    top: -${BASE_SIZE - TAIL_SIZE}px;
    left: -${BASE_SIZE / 2}px;
    background-image: url(${pointSrc});
  `,
}
